namespace Ordinality {
  export const abbriviated = (() => {
    const suffixes = ["st", "nd", "rd"];
    return (n: number) =>
      `${n}${(Math.floor(n / 10) !== 1 && suffixes[(n % 10) - 1]) || "th"}`;
  })();
  export const word = (() => {
    const ones = [
      "first",
      "second",
      "third",
      "fourth",
      "fifth",
      "sixth",
      "seventh",
      "eighth",
      "ninth",
      "tenth",
      "eleventh",
      "twelfth",
      "thirteenth",
      "fourteenth",
      "fifteenth",
      "sixteenth",
      "seventeenth",
      "eighteenth",
      "nineteenth",
    ];
    // eslint-disable-next-line no-sparse-arrays
    const tens = [
      ,
      ,
      "twenty",
      "thirty",
      "forty",
      "fifty",
      "sixty",
      "seventy",
      "eighty",
      "ninety",
    ];

    return (n: number) => {
      if (n in ones) return ones[n - 1];
      if (n % 10 === 0) return `${tens[n / 10]!.slice(0, -1)}ieth`;
      return `${tens[Math.floor(n / 10)]}-${ones[(n % 10) - 1]}`;
    };
  })();
}

export default Ordinality;
